import React from 'react'
import { useModal } from '../../../components/useModal'
import { useExportToXLS } from '../../../lib/hooks/useExportToXLS'
import GhostButton from '../../../components/Buttons/GhostButton'
import { startCase } from 'lodash'
import { Button } from '@demandlocal/components'
import CustomersFTPUpload from '../UploadCustomers/CustomersFTPUpload'
import { UseMutationResult } from 'react-query'

type Props = {
  ftpUploadCSVMutation: UseMutationResult<unknown>
  databaseColumns?: Array<string>
}

const SourcePickerFTP = (props: Props): JSX.Element => {
  const { ftpUploadCSVMutation, databaseColumns } = props
  const { handleModal } = useModal()
  const { exportToCSV } = useExportToXLS()

  return (
    <div
      className={
        'py-10 px-6 rounded-lg font-Spartan flex-1 flex items-center flex-col bg-cultured-gray'
      }>
      <div className={'flex-1 flex flex-col items-center'}>
        <div className={'font-bold text-base'}>Import from FTP</div>
        <div className={'font-medium pt-2 text-xs text-davy-gray'}>
          Connect to your CRM or source
        </div>
        <div className={'font-medium pt-2 text-xs text-davy-gray'}>
          Accepted formats: CSV
        </div>
        <GhostButton
          transparent={true}
          onClick={(e) => {
            e.preventDefault()
            exportToCSV(
              [(databaseColumns ?? [])?.map((column) => startCase(column))],
              'dl_saas_template.csv',
              true,
              'csv',
            )
          }}>
          Download CSV Template
        </GhostButton>
      </div>
      <div className={'pt-12 w-full px-6'}>
        <div className={'flex items-center justify-center'}>
          <Button
            variant={'secondary'}
            onClick={(e) => {
              e.preventDefault()
              handleModal(
                <CustomersFTPUpload
                  ftpUploadCSVMutation={ftpUploadCSVMutation}
                  databaseColumns={databaseColumns}
                />,
              )
            }}>
            Import
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SourcePickerFTP
